import { NextCustomImage } from 'components/Image';
import Link from 'components/Globals/Base/Link';
import RawHtml from 'utils/miscUtils/rawHtml';
import SvgIcon from 'components/Globals/Base/SvgIcon';
import type { AuthorHeroConfig } from 'interfaces/content/articles/Articles';
import * as S from 'components/AuthorHero/AuthorHeroStyles';

const AuthorHero = ({
  avatarUrl,
  description,
  displayEmail,
  displayName,
  instaHandle,
  instaUrl,
  linkedinHandle,
  linkedinUrl,
  twitterHandle,
  twitterUrl,
}: AuthorHeroConfig) => (
  <div className='author-hero'>
    <S.AuthorName
      as='h1'
      $fontFamily='graphikCond'
      $size={{ default: 'large', mdMin: 'xlarge', xxlMin: 'xxlarge' }}
    >
      {displayName}
    </S.AuthorName>
    <S.AuthorHeroContainer>
      {avatarUrl && (
        <S.AuthorImage>
          <NextCustomImage
            src={avatarUrl}
            alt={`${displayName}`}
            width='200'
            height='200'
          />
        </S.AuthorImage>
      )}
      {description && <S.AuthorDescription>{RawHtml({ html: description })}</S.AuthorDescription>}
    </S.AuthorHeroContainer>
    <S.AuthorSocials>
      <ul className='social-list'>
        {displayEmail && (
          <Link
            href={`mailto:${displayEmail}`}
            className='social'
          >
            <SvgIcon name='Email' />
            {displayEmail}
          </Link>
        )}
        {twitterHandle && (
          <Link
            href={twitterUrl}
            className='social'
          >
            <SvgIcon name='Twitter' />@{twitterHandle}
          </Link>
        )}
        {linkedinHandle && (
          <Link
            href={linkedinUrl}
            className='social'
          >
            <SvgIcon name='LinkedIn' />
            {linkedinHandle}
          </Link>
        )}
        {instaHandle && (
          <Link
            href={instaUrl}
            className='social'
          >
            <SvgIcon name='Instagram' /> {instaHandle}
          </Link>
        )}
      </ul>
    </S.AuthorSocials>
  </div>
);

export default AuthorHero;
